<template>
  <v-container>
    <h2 class="mb-4">🤖 Oto Bot Sistemi</h2>

    <!-- AFK -->
    <v-card class="mb-6">
      <v-card-title>AFK Ayarları</v-card-title>
      <v-card-text>
        <v-text-field
          label="Idle Süresi (dk)"
          type="number"
          v-model.number="afk.idle_min"
        />

        <v-select
          label="AFK Kanalı"
          :items="channels"
          item-text="channelName"
          item-value="cid"
          v-model="afk.afk_channel_id"
        />

        <v-select
          label="Hariç Kanallar"
          :items="channels"
          item-text="channelName"
          item-value="cid"
          v-model="afk.ignore_channel_ids"
          multiple
        />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="saveAfk">Kaydet</v-btn>
      </v-card-actions>
    </v-card>

    <!-- AUTOGROUP -->
    <v-card>
      <v-card-title>Auto Group (Tag Sistemi)</v-card-title>
      <v-card-text>
        <v-text-field
          label="Tag Regex"
          v-model="auto.tag_regex"
          placeholder="\\[PAL\\]"
        />

        <v-select
          label="Tag'lı Grup"
          :items="groups"
          item-text="name"
          item-value="sgid"
          v-model="auto.tag_group"
        />

        <v-select
          label="Guest Grup"
          :items="groups"
          item-text="name"
          item-value="sgid"
          v-model="auto.guest_group"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="saveAuto">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      channels: [],
      groups: [],
      afk: {
        idle_min: 10,
        afk_channel_id: null,
        ignore_channel_ids: [],
      },
      auto: {
        tag_regex: "\\[PAL\\]",
        tag_group: null,
        guest_group: null,
      },
    };
  },

  async mounted() {
    const BASE = process.env.VUE_APP_BASE_PATH || "";

    const { data } = await axios.get(`${BASE}/api/public/ts3/view`);

    this.channels = data.channelList || [];
    this.groups = data.serverGroupList || [];
  },

  methods: {
    toast(type, msg) {
      if (this.$toast && typeof this.$toast[type] === "function") {
        this.$toast[type](msg);
      }
    },

    async saveAfk() {
      await axios.put("/api/bot/rules/afk", this.afk);
      this.toast("success", "AFK ayarları kaydedildi");
    },

    async saveAuto() {
      await axios.put("/api/bot/rules/autogroup", this.auto);
      this.toast("success", "AutoGroup kaydedildi");
    },
  },
};
</script>
